/**
 * React entry point — mounts <App/> into the #root element of
 * public/index.html. This is the staff/client portal SPA; the
 * standalone eye-exam chart under optivet-webapp/ is NOT part of this
 * bundle (FastAPI serves it as plain static files at /exam-chart).
 */

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Suppress ResizeObserver loop error (benign error from rapid DOM changes).
// ResizeObserver "loop" warnings fire when a layout pass triggers another
// resize observation before the browser finishes delivering the first batch —
// common with tables/charts resizing during render. It's a spec-mandated
// browser warning, not a real failure; the dev-server overlay however turns it
// into a red error screen, so this hides the overlay element and swallows the
// event. Note it only suppresses the *overlay*, not the underlying layout churn.
const suppressResizeObserverError = () => {
  const resizeObserverErrHandler = (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
      const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
      if (resizeObserverErr) {
        resizeObserverErr.style.display = 'none';
      }
      e.stopImmediatePropagation();
    }
  };
  
  window.addEventListener('error', resizeObserverErrHandler);
};

suppressResizeObserverError();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
